<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/DHT1/DHT1.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">2DHT130</div>
                <div class="detail-banner-desc transmission">Dual-motor 2-speed DHT

                    <div class="detail-desc">
                        <div>
                            Smart Mode Switching: Range extension at low speeds; Direct
                            drive at medium and high speeds;<br />
                        </div>
                        <div>
                            Full-Scenario Coverage: Two-speed engine direct drive with
                            “3 Power Sources & 9 Operating Modes”;<br />
                        </div>
                        <div>
                            High speed condition with efficient direct drive meanwhile P3 E-motor Disconnect to reduce
                            losses.<br />
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters: TM
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">130kW</div>
                                    <div class="k">Peak Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">295N·m</div>
                                    <div class="k">Peak Torque</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">18500rpm</div>
                                    <div class="k">Maximum Speed</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1</div>
                                    <div class="k">Gear</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/DHT1/DHT1-2.jpg" alt="200-1-02">
                    </div>
                </div>

            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '2DHT130 - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/transmission/DHT1.html'

};

import { createApp } from 'vue';
import App from './DHT1.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./DHT1.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
